import { useMutation } from "@apollo/client";
import { UpdateDayRangeFlexibilityInput } from "@clockwise/schema";
import { UpdateEventFlexibilityDocument } from "@clockwise/web-commons/src/ui/autopilot-flexibility/__generated__/UpdateEventFlexibility.generated";
import { useOrgId } from "../../hooks/useOrgId";

export const useToggleFlexibility = (externalEventId: string, calendarId: string) => {
  const { orgId } = useOrgId();
  const [editEventFlexibility, { loading: updating, error: updateError }] = useMutation(
    UpdateEventFlexibilityDocument,
  );

  const update = async ({
    variables: { toggleToOn },
    onCompleted,
    onError,
  }: {
    variables: { toggleToOn: boolean };
    onCompleted?: () => void;
    onError?: () => void;
  }) => {
    let input: UpdateDayRangeFlexibilityInput = {
      orgRelayId: orgId,
      dayOfWeekFlexibleEvents: [],
      weekFlexibleEvents: [],
      dayFlexibleEvents: [],
      notFlexibleEvents: [externalEventId],
    };
    if (toggleToOn === true) {
      input = {
        orgRelayId: orgId,
        dayOfWeekFlexibleEvents: [],
        weekFlexibleEvents: [],
        dayFlexibleEvents: [externalEventId],
        notFlexibleEvents: [],
      };
    }
    await editEventFlexibility({
      variables: {
        CalendarId: calendarId,
        input,
      },
      onCompleted,
      onError,
    });
  };

  return {
    update,
    updating,
    updateError,
  };
};
